<br />
<mat-expansion-panel expanded="true">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <h6 class="titulo-solicitud">Informe De Entregas X Transportador</h6>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <div class="contenedor-form">
    <form
      [formGroup]="entregasGroup"
      (ngSubmit)="busqueda()"
      class="example-form"
    >
      <div class="row">
        <div class="col s12 m6 l2">
          <span *ngIf="loadingAgencias">
            <mat-spinner
              [diameter]="30"
              style="margin:0 auto; top:15px;"
            ></mat-spinner>
          </span>
          <span *ngIf="!loadingAgencias">
            <mat-form-field appearance="outline" >
              <mat-label>Agencia</mat-label>
              <mat-select
                formControlName="idAgencia"
                (change)="cargarUsuariosAgencia()"
              >
                <mat-option
                  *ngFor="let agencia of agencias"
                  [value]="agencia.id"
                >
                  {{ agencia.valor }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </span>
        </div>
        <div class="col s12 m6 l4">
          <span *ngIf="loadingUsuarios">
            <mat-spinner
              [diameter]="30"
              style="margin:0 auto; top:15px;"
            ></mat-spinner>
          </span>
          <span *ngIf="!loadingUsuarios">
            <mat-form-field class="example-full-width" appearance="outline" >
              <mat-label>Transportador</mat-label>
              <input
                matInput
                placeholder="Transportador"
                [matAutocomplete]="auto"
                formControlName="usuarioCtrl"
              />
              <mat-autocomplete
                #auto="matAutocomplete"
                [displayWith]="displayFn"
              >
                <mat-option
                  *ngFor="let usuario of filteredUsuarios | async"
                  [value]="usuario"
                >
                  <span>{{ usuario.valor }}</span>
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </span>
        </div>
        <div class="col s12 m6 l2">
          <mat-form-field appearance="outline" >
            <mat-label>Fecha Inicial</mat-label>
            <input
              formControlName="fechaInicial"
              readonly
              matInput
              [matDatepicker]="picker"
              placeholder="Fecha Inicial"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="picker"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="col s12 m6 l2">
          <mat-form-field appearance="outline" >
            <mat-label>Fecha Final</mat-label>
            <input
              formControlName="fechaFinal"
              readonly
              matInput
              [matDatepicker]="picker1"
              placeholder="Fecha Final"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="picker1"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="col s12 m6 l2">
          <button
            mat-raised-button
            color="accent"
            type="submit"
            [disabled]="!entregasGroup.valid || loading"
          >
            Consultar
          </button>
        </div>
      </div>
    </form>
  </div>
</mat-expansion-panel>

<br />
<mat-expansion-panel expanded="true">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <h5 class="titulo-solicitud">Entregas Realizadas</h5>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <div class="row">
    <div class="col s12 m12 l12">
        <form [formGroup]="searchForm">
        <mat-form-field>
        <input formControlName="searchText" matInput placeholder="BUSCAR" />
        <mat-icon matSuffix>search</mat-icon>
        <mat-hint>ORDEN SAP/ENTREGA SALIDA/PEDIDO/ARTICULO/NOMBRE CLIENTE/CONDUCTOR</mat-hint>
        </mat-form-field>
        </form>
    </div>
  </div>
  <div class="row">
    <div class="col s12 m2 l2"></div>
    <div class="col s12 m8 l8" *ngIf="loading" style="text-align: center;">
            <mat-spinner
            [diameter]="100"
            style="margin:0 auto; top:15px;"
          ></mat-spinner>
    </div>
    <div class="col s12 m8 l8" *ngIf="!loading && dataEntregas.length==0" style="text-align: center;">
        <br>
        <mat-card>
            <h5 style="color: grey; font-weight: bold;">No hay información para mostrar</h5>
        </mat-card>
    </div>
    <div class="col s12 m8 l8" *ngIf="!loading && dataEntregas.length>0">
        <div class="row">
            <div class="col s12 m12 l12" style="text-align: right;">
                    <button mat-icon-button matTooltip="EXPORTAR A EXCEL" (click)="exportarExcel();" matTooltipPosition="above">
                        <mat-icon svgIcon="excel"></mat-icon>
                    </button>
            </div>
        </div>
      <mgl-timeline [alternate]="alternate" side="right">
        <mgl-timeline-entry
          *ngFor="let item of dataEntregas | filter: searchForm.get('searchText').value; let i = index"
          id="{{ i }}"
        >
          <mgl-timeline-entry-header
            (click)="onHeaderClick($event, i)"
            style="cursor: pointer; text-align: center;"
          >
<div style="background-color: gray; margin-left: 10px;">
            <span style="font-weight: bold; color: #FFFFFF;">Número Documento: </span
            ><span style="color: #FFFFFF;">{{ item.numeroDocumento }}</span>
          </div>
          </mgl-timeline-entry-header>
          <mgl-timeline-entry-content>
            <div class="row">
              <div class="col s12 m6 l6" style="text-align: left;">
                <span style="font-weight: bold;">Número Manifiesto:</span>
                {{ item.EntregaSalida }}
              </div>
              <div class="col s12 m6 l6" style="text-align: left;">
                <span style="font-weight: bold;">Número Remisión:</span>
                {{ item.Pedido }}
            </div>
            </div>
            <div class="row">
                <div class="col s12 m12 l12" style="text-align: left;">
                    <span style="font-weight: bold;">Articulo:</span>
                    {{ item.Articulo }}
                </div>
            </div>
            <div class="row">
                <div class="col s12 m12 l12" style="text-align: left;">
                    <span style="font-weight: bold;">Cliente:</span>
                    {{ item.Nombre }}
                </div>
            </div>
            <div class="row">
                <div class="col s12 m6 l6" style="text-align: left;">
                    <span style="font-weight: bold;">Ciudad Destino:</span>
                    {{ item.Ciudad }}
                </div>
                <div class="col s12 m6 l6" style="text-align: left;">
                    <span style="font-weight: bold;">Telefono:</span>
                    {{ item.Telefono }}
                </div>
            </div>
            <div class="row">
                <div class="col s12 m6 l6" style="text-align: left;">
                    <span style="font-weight: bold;">Tienda:</span>
                    {{ item.Tienda }}
                </div>
                <div class="col s12 m6 l6" style="text-align: left;">
                    <span style="font-weight: bold;">Cantidad:</span>
                    {{ item.Cantidad }}
                </div>
            </div>
            <div class="row">
              <div class="col s12 m12 l12" style="text-align: left;">
                  <span style="font-weight: bold;">Cantidad Final:</span>
                  {{ item.CantidadFinal }}
              </div>
            </div>
            <div class="row">
                <div class="col s12 m6 l6" style="text-align: left;">
                    <span style="font-weight: bold;">Placa:</span>
                    {{ item.Placa }}
                </div>
            </div>
            <div class="row">
                <div class="col s12 m12 l12" style="text-align: left;">
                    <span style="font-weight: bold;">Conductor:</span>
                    {{ item.NroDocId }} -- {{ item.Conductor }}
                </div>
            </div>
            <div class="row">
              <div class="col s12 m12 l12" style="text-align: left;">
                  <span style="font-weight: bold;">Observaciones:</span>
                  {{ item.Observaciones }}
              </div>
          </div>
          <div class="row">
            <div class="col s12 m12 l12" style="text-align: left;">
                <span style="font-weight: bold;">Novedad:</span>
                {{ item.descripcionMotivoPaquete }}
            </div>
        </div>
        <div class="row">
          <div class="col s12 m12 l12" style="text-align: left;">
              <span style="font-weight: bold;">Fecha Y Hora Entrega:</span>
              {{item.fechaServicio | date: "yyyy-MM-dd hh:mm:ss a"}}
          </div>
      </div>
      <div class="row">
        <div class="col s12 m12 l12" style="text-align: left;">
            <span style="font-weight: bold;">Fecha Manifiesto:</span>
            {{item.fechaManifiesto | date: "yyyy-MM-dd hh:mm:ss a"}}
        </div>
    </div>
            <div class="row">
              <div class="col s4 m4 l4" style="text-align: center;">
                    <span style="font-weight: bold;">DOCUMENTO</span>
              </div>
              <div class="col s4 m4 l4" style="text-align: center;">
                    <span style="font-weight: bold;">FOTO</span>
              </div>
              <div class="col s4 m4 l4" style="text-align: center;">
                    <span style="font-weight: bold;">FIRMA</span>
              </div>
            </div>
            <div class="row">
              <div class="col s4 m4 l4" style="text-align: center;">
                <mat-icon
                  style="cursor: pointer;"
                  *ngIf="item.tieneDocumento > 0"
                  (click)="verDocumento(item.ordensap, item.idServicioPaquete, 3)"
                  color="accent"
                  matTooltip="DOCUMENTO"
                  matTooltipPosition="above"
                >
                  description
                </mat-icon>
                <mat-icon
                  *ngIf="item.tieneDocumento == 0"
                  matTooltip="SIN DOCUMENTO"
                  matTooltipPosition="above"
                >
                  not_interested
                </mat-icon>
              </div>
              <div class="col s4 m4 l4" style="text-align: center;">
                <mat-icon
                  style="cursor: pointer;"
                  *ngIf="item.tieneFoto > 0"
                  (click)="verDocumento(item.ordensap, item.idServicioPaquete, 1)"
                  color="accent"
                  matTooltip="FOTO"
                  matTooltipPosition="above"
                >
                  photo
                </mat-icon>
                <mat-icon
                  *ngIf="item.tieneFoto == 0"
                  matTooltip="SIN FOTO"
                  matTooltipPosition="above"
                >
                  not_interested
                </mat-icon>
              </div>
              <div class="col s4 m4 l4" style="text-align: center;">
                <mat-icon
                  style="cursor: pointer;"
                  *ngIf="item.tieneFirma > 0"
                  (click)="verDocumento(item.ordensap, item.idServicioPaquete, 2)"
                  color="accent"
                  matTooltip="FIRMA"
                  matTooltipPosition="above"
                >
                  fingerprint
                </mat-icon>
                <mat-icon
                  *ngIf="item.tieneFirma == 0"
                  matTooltip="SIN FIRMA"
                  matTooltipPosition="above"
                >
                  not_interested
                </mat-icon>
              </div>
            </div>
          </mgl-timeline-entry-content>
          <mgl-timeline-entry-dot
            (click)="onDotClick($event, i)"
            [style.background-color]="item.idTpoNovedad==1 ? '#008000' : item.idTpoNovedad==3 ? '#FFA500' : (item.idTpoNovedad==2 ? '#ff0000' : null)"
            class="click"
          >
          </mgl-timeline-entry-dot>
          <mgl-timeline-entry-side>
            <span >{{item.fechaNovedad | date: "yyyy-MM-dd hh:mm:ss a"}}</span>
            <br>
            <span style="color: #A0A0A0;">{{ item.Conductor }}</span>
          </mgl-timeline-entry-side>
        </mgl-timeline-entry>
      </mgl-timeline>
    </div>
    <div class="col s12 m2 l2"></div>
  </div>
</mat-expansion-panel>
